var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"text":"","outlined":"","type":_vm.type || 'success',"icon":_vm.icon,"elevation":"2","dismissible":_vm.dismissible},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.msg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }